export const buildWaterfall = (rows, labelKey, valueKey, totalKey = "is_total") => {
  let cumulative = 0;
  return (rows ?? []).map((r) => {
    const value = Number(r[valueKey]) || 0;
    const isTotal = !!r[totalKey];

    if (isTotal) {
      return { name: r[labelKey], base: 0, bar: value, value, type: "total" };
    }
    const start = cumulative;
    const end = cumulative + value;
    cumulative = end;
    return {
      name: r[labelKey],
      base: Math.min(start, end), // float bar to the lower of the two
      bar: Math.abs(value),       // visible height
      value,
      type: value < 0 ? "decrease" : "increase",
    };
  });
};